import React, { FC, useContext, useEffect, useRef, useState } from 'react'
// import ButtonUpload from './Button/Upload'
import ButtonSend from './Button/Send'
import ButtonEmoji from './Button/Emoji'
import ButtonUpload from './Button/Upload'
import ButtonRedirect from './Button/Redirect'
import EmojiPicker from './EmojiPicker'
import { ChatContext } from '~/service/chatConn'
import AutoCompletion from './Button/AutoCompletion'
import AnswerCorrection from './Button/AnswerCorrection'
import ButtonCannedResponse from './Button/CannedResponse'
import SentenceCompletion from './Button/SentenceCompletion'
import AiCompletionCancel from './Button/AiCompletionCancel'
import { FormType } from '.'
import { Control, UseFormSetValue } from 'react-hook-form'
import { DropzoneInputProps, DropzoneRootProps } from 'react-dropzone'
import AiLang from './Button/AiLang'

type ButtonsProps = {
  anyContent: boolean
  inputRef: React.MutableRefObject<HTMLTextAreaElement | undefined>
  setValue: UseFormSetValue<FormType>
  redirectToStory?: number
  control: Control<FormType, any>
  getInputProps: <T extends DropzoneInputProps>(props?: T | undefined) => T
  getRootProps: <T extends DropzoneRootProps>(props?: T | undefined) => T
  disabledSubmit: boolean
  aiLang: string
}

const Buttons: FC<ButtonsProps> = ({
  anyContent,
  inputRef,
  setValue,
  redirectToStory,
  control,
  getInputProps,
  getRootProps,
  disabledSubmit,
  aiLang,
}) => {
  const emojiPickerTriggerRef = useRef<HTMLButtonElement>(null)
  const [emojiPicker, setEmojiPicker] = useState(false)
  const { sendMessage } = useContext(ChatContext)
  const { activeChat } = useContext(ChatContext)
  const aiCompletion = !!activeChat.aiCompletion

  useEffect(() => {
    if (!emojiPicker) {
      setTimeout(() => {
        inputRef.current && inputRef.current.focus()
      })
    }
  }, [emojiPicker])

  return (
    <div className="chat-input-buttons-wrapper">
      <EmojiPicker
        active={emojiPicker}
        hide={() => {
          setEmojiPicker(false)
        }}
        handleEmojiSelect={sendMessage}
        triggerRef={emojiPickerTriggerRef}
      />

      <div className="chat-input-buttons">
        <fieldset className="chat-input-buttons-group" disabled={aiCompletion}>
          {window.c.chatAttachments && (
            <ButtonUpload
              getInputProps={getInputProps}
              getRootProps={getRootProps}
              disabled={!!redirectToStory}
            />
          )}

          <ButtonEmoji
            buttonRef={emojiPickerTriggerRef}
            onClick={() => setEmojiPicker(!emojiPicker)}
            active={emojiPicker}
            disabled={!!redirectToStory}
          />

          <ButtonCannedResponse
            setValue={setValue}
            inputRef={inputRef}
            disabled={anyContent}
          />

          <ButtonRedirect control={control} redirectToStory={redirectToStory} />
        </fieldset>

        {(window.c.openAi || window.c.llama) && (
          <>
            <div className="chat-input-buttons-divider"></div>
            <fieldset
              className="chat-input-buttons-group"
              disabled={aiCompletion}
            >
              {window.c.openAiChat.answerCorrection && (
                <AnswerCorrection
                  inputRef={inputRef}
                  disabled={!anyContent}
                  aiLang={aiLang}
                />
              )}
              {window.c.openAiChat.sentenceCompletion && (
                <SentenceCompletion
                  inputRef={inputRef}
                  disabled={!anyContent}
                  aiLang={aiLang}
                />
              )}
              {window.c.openAiChat.autoCompletion && (
                <AutoCompletion
                  disabled={anyContent || !!redirectToStory}
                  aiLang={aiLang}
                />
              )}

              {window.c.llama && <AiLang control={control} />}
            </fieldset>
          </>
        )}

        <AiCompletionCancel />

        <div className="chat-input-buttons-group">
          <ButtonSend
            key="send"
            disabled={disabledSubmit}
            redirectToStory={redirectToStory}
          />
        </div>
      </div>
    </div>
  )
}

export default Buttons
